import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class WorkFlowService {
  baseUrl: string = environment.API_SERVER;
  constructor(private _http: HttpClient) {}
  workflow = '';
  workFlowType = '';
  getWorkFlow(payload) {
    return this._http.get(
      `${this.baseUrl}/collaborators/${payload.organizationId}/work_flows/`,
      {
        params: payload.params,
      }
    );
  }
  getAllOrganizationUnits(payload) {
    const url = `${this.baseUrl}/organizations/filter`;
    return this._http.get<any>(url, { params: payload.params });
  }

  getWorkFlowGroup(payload) {
    return this._http.get(
      `${this.baseUrl}/collaborators/${payload.organizationId}/work_flows/${payload.workFlowId}/type/${payload.workFlowType}/`,
      { params: payload.params }
    );
  }

  addWorkFlow(payload) {
    return this._http.post(
      `${this.baseUrl}/collaborators/${payload.organizationId}/work_flows/`,
      payload.body
    );
  }

  activateWorkFlow(payload) {
    return this._http.put(
      `${this.baseUrl}/collaborators/${payload.organizationId}/work_flows/${payload.workFlowId}/type/${payload.workFlowType}/`,
      payload.body
    );
  }
  deactivateWorkFlow(payload) {
    return this._http.delete(
      `${this.baseUrl}/collaborators/${payload.organizationId}/work_flows/${payload.workFlowId}/type/${payload.workFlowType}/`,
      payload.body
    );
  }

  getWorkFlowUsers(payload) {
    return this._http.get(
      `${this.baseUrl}/collaborators/${payload.organizationId}/work_flows/${payload.workFlowId}/type/${payload.workFlowType}/users/`,
      { params: payload.params }
    );
  }
  addWorkFlowUsers(payload) {
    return this._http.post(
      `${this.baseUrl}/collaborators/${payload.organizationId}/work_flows/${payload.workFlowId}/type/${payload.workFlowType}/users/`,
      payload.body
    );
  }
  updateWorkFlowUsers(payload) {
    return this._http.put(
      `${this.baseUrl}/collaborators/${payload.organizationId}/work_flows/${payload.workFlowId}/type/${payload.workFlowType}/users/`,
      payload.body
    );
  }
  removeWorkFlowUsers(payload) {
    return this._http.delete(
      `${this.baseUrl}/collaborators/${payload.organizationId}/work_flows/${payload.workFlowId}/type/${payload.workFlowType}/users/${payload.body}/`
    );
  }
}
